import { render, staticRenderFns } from "./SchoolBasic.vue?vue&type=template&id=1fa0dfe1&"
import script from "./SchoolBasic.vue?vue&type=script&lang=js&"
export * from "./SchoolBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports